module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 94.3d43c8fe.png";